import {Component, inject, OnInit} from '@angular/core'
import {ConfigService} from '../../services/config.service'
import {Router} from '@angular/router'

@Component({
  selector: 'smt-logout',
  template: ''
})
export class Logout implements OnInit {
  private readonly service = inject(ConfigService)
  private readonly router = inject(Router)

  public ngOnInit() {
    this.service.logout()
    this.router.navigate(['/', 'login']).then()
  }
}
